import "./logout.scss";
import { makeRequest } from "../../axios";
import Dismissal from "../../assets/dismissal.png";

const Logout = ({setShowLogout}) => {


  const handleLogout = async () =>{
    // makeRequest.post("/auth/logout");
    localStorage.removeItem("user");
    window.location.reload();
  }

  return (
    <div className="logout">
      <div className="wrapper">
        <span className="text-header">Are you sure you want to</span>
        <div className="dis">
          <img className="dismissal" src={Dismissal} alt=""/>
        </div>
        <span style={{ fontWeight: 400, fontSize: 15 }}>LOG OUT ?</span>
        <div className="options">
          <button onClick={handleLogout}>Yes</button>
          <button onClick={() => setShowLogout(false)}>Not Yet</button>
        </div>
        <button className="close" onClick={() => setShowLogout(false)}>
          close
        </button>
      </div>
    </div>
  );
};

export default Logout;
